import React from "react";
import ReactDOM from "react-dom";
import './index.css';


import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import HomePage from './components/HomePage';
import Project from "./components/Project";
import ContactPage from "./components/ContactPage";
import AboutPage from "./components/AboutPage";
import LoginPage from "./components/LoginPage";
import JoinProServicePage from './components/JoinProServicePage';
import JoinUs from './components/JoinUs';


ReactDOM.render(
  <Router>
    <Routes>
      <Route exact path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/project" element={<Project />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/join-pro-service" element={<JoinProServicePage />} />
        <Route path="/join-us" element={<JoinUs />} />
    </Routes>
  </Router>,
  document.getElementById("root")
);

reportWebVitals();